export default __webpack_public_path__ + "static/media/wbtc-satoshi.4ae21855.svg";